module.exports = __webpack_public_path__ + "static/media/0296_Medium.90ffdf2a.jpg";